import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import axios from 'axios';

const AddProductTag = () => {
  const [show, setShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState('');
  const [tagName, setTagName] = useState('');
  const [tags, setTags] = useState([]);
  const [editTagId, setEditTagId] = useState(null);
  const [editTagName, setEditTagName] = useState('');
  const [editProductId, setEditProductId] = useState('');

  // Function to fetch products from the API
  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://api.biznetusa.com/api/get-products');
      if (response.data.products) {
        setProducts(response.data.products); // Use the correct path for products
      } else {
        console.error('Error: Products not found in response.');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  // Function to fetch tags from the API
  const fetchTags = async () => {
    try {
      const response = await axios.get('https://api.biznetusa.com/api/get-productoverviewhome');
      setTags(response.data.overview_home_section_tags);
    } catch (error) {
      console.error('Error fetching tags:', error);
    }
  };

  // Fetch product IDs and tags when the component mounts
  useEffect(() => {
    fetchProducts();
    fetchTags();
  }, []);

  // Handle form submission to add a tag
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://api.biznetusa.com/api/store-productoverviewhome', {
        p_id: selectedProductId,
        tag_name: tagName,
      });
      alert('Tag added successfully!');
      setShow(false);
      fetchTags(); // Re-fetch tags to update the table
    } catch (error) {
      console.error('Error adding tag:', error);
    }
  };

  // Handle Edit Tag
  const handleEdit = (tag) => {
    setEditTagId(tag.id);
    setEditTagName(tag.tag_name);
    setEditProductId(tag.pd_id); // Set the current product ID for editing
    setEditShow(true);
  };

  // Handle updating a tag
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://api.biznetusa.com/api/update-productoverviewhome/${editTagId}`, {
        p_id: editProductId, // Send the selected product ID during the edit
        tag_name: editTagName,
      });
      alert('Tag updated successfully!');
      setEditShow(false);
      fetchTags(); // Re-fetch tags to update the table
    } catch (error) {
      console.error('Error updating tag:', error);
    }
  };

  // Handle deleting a tag
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deleteproductoverviewhome/${id}`);
      alert('Tag deleted successfully!');
      fetchTags(); // Re-fetch tags to update the table
    } catch (error) {
      console.error('Error deleting tag:', error);
    }
  };

  return (
    <div>
      <Button variant="primary mt-4" onClick={() => setShow(true)}>
        Add Tag
      </Button>

      {/* Add Tag Modal */}
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Product Tag</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formProduct">
              <Form.Label>Select Product</Form.Label>
              <Form.Control
                as="select"
                value={selectedProductId}
                onChange={(e) => setSelectedProductId(e.target.value)}
                required
              >
                <option value="">Select a product</option>
                {products.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name || product.title} (ID: {product.id})
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formTagName">
              <Form.Label>Tag Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Tag Name"
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Add Tag
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Tag Modal */}
      <Modal show={editShow} onHide={() => setEditShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Product Tag</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdate}>
            <Form.Group controlId="formProductEdit">
              <Form.Label>Select Product</Form.Label>
              <Form.Control
                as="select"
                value={editProductId}
                onChange={(e) => setEditProductId(e.target.value)}
                required
              >
                <option value="">Select a Product</option>
                {products.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name || product.title} (ID: {product.id})
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formTagNameEdit">
              <Form.Label>Tag Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Edit Tag Name"
                value={editTagName}
                onChange={(e) => setEditTagName(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Update Tag
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <h3>Existing Tags</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Product ID</th>
            <th>Tag Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tags.map((tag) => (
            <tr key={tag.id}>
              <td>{tag.id}</td>
              <td>{tag.pd_id}</td>
              <td>{tag.tag_name}</td>
              <td>
                <Button variant="warning" onClick={() => handleEdit(tag)}>
                  Edit
                </Button>{' '}
                <Button variant="danger" onClick={() => handleDelete(tag.id)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AddProductTag;
